import { useState, useEffect } from 'react';
import { employeesAPI, commissionAPI } from '../../services/api';
import toast from 'react-hot-toast';

const fmt = v => `R$ ${parseFloat(v||0).toFixed(2).replace('.',',')}`;
const inp = { width:'100%', padding:'9px 12px', border:'1.5px solid #E5E7EB', borderRadius:8, outline:'none', boxSizing:'border-box', fontSize:'.9rem' };
const lbl = { display:'block', fontWeight:600, fontSize:'.8rem', marginBottom:5, color:'#374151' };
const ROLES = ['employee','manager','attendant','financial'];

export default function EmployeePage() {
  const [employees, setEmployees] = useState([]);
  const [commissions, setCommissions] = useState([]);
  const [loading, setLoading]  = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm]         = useState({ name:'', email:'', phone:'', role:'employee', commission_type:'none', commission_value:0, active:1 });
  const [editing, setEditing]   = useState(null);
  const [activeTab, setActiveTab] = useState('employees');
  const [commFilters, setCommFilters] = useState({ status:'pending', employee_id:'', page:1 });

  const load = async () => {
    setLoading(true);
    try { const r = await employeesAPI.list(); setEmployees(r.data.data || []); }
    finally { setLoading(false); }
  };

  const loadCommissions = async () => {
    try {
      const r = await commissionAPI.list({ ...commFilters, limit:50 });
      setCommissions(r.data.data || []);
    } catch { setCommissions([]); }
  };

  useEffect(() => { load(); }, []);
  useEffect(() => { if (activeTab === 'commissions') loadCommissions(); }, [activeTab, commFilters]);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const save = async (e) => {
    e.preventDefault();
    try {
      if (editing) await employeesAPI.update(editing.id, form);
      else         await employeesAPI.create(form);
      toast.success(editing ? 'Colaborador atualizado!' : 'Colaborador cadastrado!');
      setShowForm(false); setEditing(null); setForm({ name:'', email:'', phone:'', role:'employee', commission_type:'none', commission_value:0, active:1 }); load();
    } catch (err) { toast.error(err.response?.data?.message || 'Erro.'); }
  };

  const startEdit = (e) => { setEditing(e); setForm({ name:e.name, email:e.email||'', phone:e.phone||'', role:e.role||'employee', commission_type:e.commission_type||'none', commission_value:e.commission_value||0, active:e.active??1 }); setShowForm(true); };

  const del = async (id) => {
    if (!window.confirm('Remover colaborador?')) return;
    try { await employeesAPI.delete(id); toast.success('Removido!'); load(); }
    catch { toast.error('Erro.'); }
  };

  const markCommPaid = async (id) => {
    try { await commissionAPI.markPaid(id); toast.success('Comissão paga!'); loadCommissions(); }
    catch { toast.error('Erro.'); }
  };

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <h1 style={{ fontSize:'1.5rem', fontWeight:700, color:'#0F172A' }}>Colaboradores</h1>
        <button onClick={()=>{setShowForm(true);setEditing(null);setForm({ name:'', email:'', phone:'', role:'employee', commission_type:'none', commission_value:0, active:1 })}}
          style={{ background:'#2563EB', color:'#fff', border:'none', borderRadius:8, padding:'10px 20px', fontWeight:600, cursor:'pointer' }}>
          + Novo Colaborador
        </button>
      </div>

      <div style={{ display:'flex', gap:0, borderBottom:'2px solid #E5E7EB', marginBottom:20 }}>
        {[['employees','Colaboradores'],['commissions','Comissões']].map(([t,l]) => (
          <button key={t} onClick={()=>setActiveTab(t)}
            style={{ padding:'10px 20px', background:'none', border:'none', cursor:'pointer', fontWeight:700, fontSize:'.9rem',
              color: activeTab===t?'#2563EB':'#6B7280', borderBottom: activeTab===t?'2px solid #2563EB':'2px solid transparent', marginBottom:-2 }}>
            {l}
          </button>
        ))}
      </div>

      {activeTab === 'employees' && (
        <div style={{ display:'grid', gap:12 }}>
          {loading && <p style={{ textAlign:'center', color:'#9CA3AF', padding:40 }}>Carregando...</p>}
          {!loading && employees.length === 0 && <p style={{ textAlign:'center', color:'#9CA3AF', padding:40 }}>Nenhum colaborador.</p>}
          {employees.map(e => (
            <div key={e.id} style={{ background:'#fff', border:'1px solid #E5E7EB', borderRadius:12, padding:'18px 20px', display:'flex', gap:16, alignItems:'center' }}>
              <div style={{ width:44, height:44, borderRadius:'50%', background:'#2563EB', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:800, fontSize:'1.1rem', flexShrink:0 }}>
                {e.name.charAt(0).toUpperCase()}
              </div>
              <div style={{ flex:1 }}>
                <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:2 }}>
                  <span style={{ fontWeight:700 }}>{e.name}</span>
                  <span style={{ background:'#EFF6FF', color:'#2563EB', borderRadius:6, padding:'1px 8px', fontSize:'.7rem', fontWeight:600, textTransform:'capitalize' }}>{e.role}</span>
                  <span style={{ background:e.active?'#D1FAE5':'#F3F4F6', color:e.active?'#065F46':'#6B7280', borderRadius:6, padding:'1px 8px', fontSize:'.7rem', fontWeight:600 }}>{e.active?'Ativo':'Inativo'}</span>
                </div>
                <div style={{ fontSize:'.8rem', color:'#6B7280' }}>
                  {e.email && <span style={{ marginRight:12 }}>{e.email}</span>}
                  {e.phone && <span>{e.phone}</span>}
                </div>
                {e.commission_type && e.commission_type !== 'none' && (
                  <div style={{ fontSize:'.75rem', color:'#9CA3AF', marginTop:2 }}>
                    Comissão: {e.commission_type === 'percentage' ? `${e.commission_value}%` : fmt(e.commission_value)} por O.S.
                  </div>
                )}
              </div>
              <div style={{ display:'flex', gap:8 }}>
                {e.orders_this_month !== undefined && (
                  <div style={{ textAlign:'center', padding:'8px 12px', background:'#F8FAFC', borderRadius:8, minWidth:60 }}>
                    <div style={{ fontWeight:700, color:'#2563EB' }}>{e.orders_this_month}</div>
                    <div style={{ fontSize:'.7rem', color:'#9CA3AF' }}>O.S./mês</div>
                  </div>
                )}
                {e.pending_commission !== undefined && (
                  <div style={{ textAlign:'center', padding:'8px 12px', background:'#FEF3C7', borderRadius:8, minWidth:70 }}>
                    <div style={{ fontWeight:700, color:'#92400E' }}>{fmt(e.pending_commission)}</div>
                    <div style={{ fontSize:'.7rem', color:'#92400E' }}>Pendente</div>
                  </div>
                )}
                <button onClick={()=>startEdit(e)} style={{ background:'#EFF6FF', color:'#2563EB', border:'none', borderRadius:6, padding:'6px 14px', cursor:'pointer', fontWeight:600, fontSize:'.8rem' }}>Editar</button>
                <button onClick={()=>del(e.id)} style={{ background:'#FEF2F2', color:'#DC2626', border:'none', borderRadius:6, padding:'6px 14px', cursor:'pointer', fontWeight:600, fontSize:'.8rem' }}>✕</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {activeTab === 'commissions' && (
        <div>
          <div style={{ display:'flex', gap:10, marginBottom:16, flexWrap:'wrap' }}>
            <select value={commFilters.status} onChange={e=>setCommFilters(f=>({...f,status:e.target.value}))} style={{ ...inp, width:'auto' }}>
              <option value="pending">Pendentes</option>
              <option value="paid">Pagas</option>
              <option value="">Todas</option>
            </select>
            <select value={commFilters.employee_id} onChange={e=>setCommFilters(f=>({...f,employee_id:e.target.value}))} style={{ ...inp, width:'auto' }}>
              <option value="">Todos colaboradores</option>
              {employees.map(e=><option key={e.id} value={e.id}>{e.name}</option>)}
            </select>
          </div>
          <div style={{ background:'#fff', borderRadius:12, border:'1px solid #E5E7EB', overflow:'hidden' }}>
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead><tr style={{ background:'#F8FAFC', borderBottom:'1px solid #E5E7EB' }}>
                {['Colaborador','O.S.','Valor','Status','Ações'].map(h=>(
                  <th key={h} style={{ padding:'12px 16px', textAlign:'left', fontSize:'.8rem', fontWeight:600, color:'#6B7280' }}>{h}</th>
                ))}
              </tr></thead>
              <tbody>
                {commissions.length === 0
                  ? <tr><td colSpan={5} style={{ padding:40, textAlign:'center', color:'#9CA3AF' }}>Nenhuma comissão.</td></tr>
                  : commissions.map(c => (
                    <tr key={c.id} style={{ borderBottom:'1px solid #F1F5F9' }}>
                      <td style={{ padding:'12px 16px', fontWeight:600 }}>{c.employee_name}</td>
                      <td style={{ padding:'12px 16px', fontSize:'.85rem', color:'#2563EB' }}>#{c.order_number}</td>
                      <td style={{ padding:'12px 16px', fontWeight:700, color:'#059669' }}>{fmt(c.amount)}</td>
                      <td style={{ padding:'12px 16px' }}>
                        <span style={{ background:c.status==='paid'?'#D1FAE5':'#FEF3C7', color:c.status==='paid'?'#065F46':'#92400E', borderRadius:6, padding:'3px 10px', fontSize:'.75rem', fontWeight:600 }}>
                          {c.status === 'paid' ? 'Paga' : 'Pendente'}
                        </span>
                      </td>
                      <td style={{ padding:'12px 16px' }}>
                        {c.status !== 'paid' && (
                          <button onClick={()=>markCommPaid(c.id)} style={{ background:'#D1FAE5', color:'#059669', border:'none', borderRadius:6, padding:'4px 12px', cursor:'pointer', fontWeight:600, fontSize:'.8rem' }}>✓ Marcar paga</button>
                        )}
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </div>
        </div>
      )}

      {showForm && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.5)', zIndex:100, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
          <div style={{ background:'#fff', borderRadius:16, padding:32, width:'100%', maxWidth:480, maxHeight:'90vh', overflowY:'auto' }}>
            <h3 style={{ fontWeight:700, marginBottom:20 }}>{editing?'Editar':'Novo'} Colaborador</h3>
            <form onSubmit={save}>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
                <div style={{ gridColumn:'1/-1' }}>
                  <label style={lbl}>Nome *</label>
                  <input value={form.name} onChange={e=>set('name',e.target.value)} required style={inp} />
                </div>
                <div>
                  <label style={lbl}>E-mail</label>
                  <input type="email" value={form.email} onChange={e=>set('email',e.target.value)} style={inp} />
                </div>
                <div>
                  <label style={lbl}>Telefone</label>
                  <input value={form.phone} onChange={e=>set('phone',e.target.value)} style={inp} />
                </div>
                <div>
                  <label style={lbl}>Função</label>
                  <select value={form.role} onChange={e=>set('role',e.target.value)} style={inp}>
                    {ROLES.map(r=><option key={r} value={r}>{r.charAt(0).toUpperCase()+r.slice(1)}</option>)}
                  </select>
                </div>
                <div>
                  <label style={lbl}>Status</label>
                  <select value={form.active} onChange={e=>set('active',Number(e.target.value))} style={inp}>
                    <option value={1}>Ativo</option>
                    <option value={0}>Inativo</option>
                  </select>
                </div>
                <div>
                  <label style={lbl}>Tipo de comissão</label>
                  <select value={form.commission_type} onChange={e=>set('commission_type',e.target.value)} style={inp}>
                    <option value="none">Sem comissão</option>
                    <option value="percentage">Percentual (%)</option>
                    <option value="fixed">Valor fixo (R$)</option>
                  </select>
                </div>
                {form.commission_type !== 'none' && (
                  <div>
                    <label style={lbl}>{form.commission_type === 'percentage' ? 'Percentual (%)' : 'Valor (R$)'}</label>
                    <input type="number" step="0.01" min="0" value={form.commission_value} onChange={e=>set('commission_value',e.target.value)} style={inp} />
                  </div>
                )}
              </div>
              <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:16 }}>
                <button type="button" onClick={()=>setShowForm(false)} style={{ padding:'10px 20px', border:'1.5px solid #E5E7EB', borderRadius:8, background:'#fff', cursor:'pointer' }}>Cancelar</button>
                <button type="submit" style={{ padding:'10px 24px', background:'#2563EB', color:'#fff', border:'none', borderRadius:8, fontWeight:700, cursor:'pointer' }}>Salvar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
